
<div 
    class="bg-slate-800 bg-opacity-50 dark:bg-opacity-70 flex justify-center items-center text-left fixed top-0 right-0 bottom-0 left-0 z-40" (appOutsideClick)="clickOutside($event)" >
    <div 
        class="bg-gradient-to-bl bg-dark-khaki-50 dark:bg-vivid-royal-950 px-16 py-5 w-full md:max-w-md rounded-2xl text-center relative" >

        <h1 class="text-xl font-medium text-medium_purple dark:text-dark-khaki-50">{{message}}</h1>
        <button class="absolute top-2 right-2 dark:text-vivid-royal-400  text-gray hover:text-gray-700"
            (click)="this.onCancel.emit()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
        </button>
        <div class="flex  items-start text-start">
            <h1 class="font-semibold text-lg text-vivid-royal-950 dark:text-white mr-2">Finanzas</h1> - <span class="ml-2 font-normal text-md text-zinc-500 dark:text-dark-khaki-50 ">Este rol puede
                realizar consulta de reportes y pagos</span>

        </div>

        <div class="flex  items-start text-start">
            <h1 class="font-semibold text-lg text-vivid-royal-950 dark:text-white mr-2">Consulta</h1> - <span class="ml-2 font-normal text-md text-zinc-500 dark:text-dark-khaki-50 ">Este rol puede
                realizar consulta de información</span>

        </div>
        <div class="flex  items-start text-start">
            <h1 class="font-semibold text-lg text-vivid-royal-950 dark:text-white mr-2">Revisión</h1> - <span class="ml-2 font-normal text-md text-zinc-500 dark:text-dark-khaki-50 ">Este rol puede
                realizar consulta de información detallada</span>
        </div>
        <div class="flex  items-start text-start">
            <h1 class="font-semibold text-lg text-vivid-royal-950 dark:text-white mr-2">Movimiento</h1> - <span class="ml-2 font-normal text-md text-zinc-500 dark:text-dark-khaki-50 ">Este rol puede
                realizar movimientos y edición de dispositivos. generar códigos QR y generar reportes</span>
        </div>
      
    </div>
</div>